<template>
  <div>
    <div class="mb-3">
      <small class="text-muted">Cambia los campos y guarda los cambios.</small>
    </div>

    <FormField
      label="Nombre"
      :required="true"
      :error="errors.firstname"
    >
      <input 
        type="text" 
        class="form-control rounded-8 sin-borde text-primary" 
        :value="studentData.firstname"
        @input="updateField('firstname', $event.target.value)"
        placeholder="Nombre del usuario"
        :class="{ 'is-invalid': errors.firstname }"
      >
    </FormField>

    <FormField label="Apellido">
      <input 
        type="text" 
        class="form-control rounded-8 sin-borde text-primary" 
        :value="studentData.lastname"
        @input="updateField('lastname', $event.target.value)"
        placeholder="Apellido del usuario"
      >
    </FormField>

    <FormField label="Email">
      <input 
        type="email" 
        class="form-control rounded-8 sin-borde text-primary" 
        :value="studentData.email"
        placeholder="Email del usuario"
        disabled
      >
      <small class="text-muted">El email no se puede modificar</small>
    </FormField>

    <FormField label="Teléfono">
      <input 
        type="tel" 
        class="form-control rounded-8 sin-borde text-primary" 
        :value="studentData.cellphone"
        @input="updateField('cellphone', $event.target.value)"
        placeholder="Teléfono del usuario"
      >
    </FormField>

    <FormField label="Área">
      <input 
        type="text" 
        class="form-control rounded-8 sin-borde text-primary" 
        :value="studentData.area"
        @input="updateField('area', $event.target.value)"
        placeholder="Área del usuario"
      >
    </FormField>

    <FormField label="Cargo">
      <input 
        type="text" 
        class="form-control rounded-8 sin-borde text-primary" 
        :value="studentData.position"
        @input="updateField('position', $event.target.value)"
        placeholder="Cargo del usuario"
      >
    </FormField>

    <FormField label="Nivel">
      <input 
        type="text" 
        class="form-control rounded-8 sin-borde text-primary" 
        :value="studentData.level"
        @input="updateField('level', $event.target.value)"
        placeholder="Nivel del usuario"
      >
    </FormField>
  </div>
</template>

<script>
import FormField from './FormField.vue'

export default {
  name: 'EditStudentForm',
  
  components: {
    FormField
  },

  props: {
    studentData: { type: Object, required: true },
    errors: { type: Object, default: () => ({}) },
    loading: { type: Boolean, default: false }
  },

  emits: ['update'],

  methods: {
    updateField(field, value) {
      this.$emit('update', { [field]: value })
    }
  }
}
</script>